// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__33wOZ","large":"styles_large__1orbw"};